import debounce from 'lodash.debounce';
import { refs, findDestisWithFaresUri, timestamp, firebaseAuth } from '../config';

export function syncUser(uid, onUser) {
  const ref = refs.usersRef.child(uid);
  ref.on('value', snap => {
    onUser(snap.val());
  });
  return ref.off;
}

export const fetchDestisWithFares = debounce(
  (origin, depDate, retDate, market, currency, oneWay, onData) => {
    firebaseAuth()
      .currentUser.getIdToken()
      .then(token => {
        const url = `${findDestisWithFaresUri}?origin=${origin}&market=${
          market
        }&currency=${currency}&departureDate=${depDate}&returnDate=${retDate}${
          oneWay ? '&oneWay=yes' : ''
        }`;
        fetch(url, {
          mode: 'cors',
          headers: {
            Authorization: 'Bearer ' + token
          }
        })
          .then(res => res.json())
          .then(onData)
          .catch(console.warn);
      });
  },
  300
);

export const saveFeedback = debounce(data => {
  refs.feedbackRef.push({
    ...data,
    ts: timestamp
  });
}, 1000);

// track refererr
const { referrer } = document;
if (referrer && !referrer.includes('localhost:') && !referrer.includes('kairos.now.sh')) {
  refs.analyticsRef.child('referrers').push({
    referrer,
    ts: timestamp
  });
}



// WEBPACK FOOTER //
// ./src/utils/firebaseUtils.js